import React, { useState, useEffect } from "react";
import { Button } from "semantic-ui-react";
import "semantic-ui-css/semantic.min.css";
import "../../styles/scss/danceCamp26Participants.scss";
import { useLoginCheck } from "../../hooks/useLoginCheck";

function formatSlot(isoString) {
  if (!isoString) return "";
  const d = new Date(isoString);
  if (isNaN(d.getTime())) return isoString;
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getMonth() + 1}/${d.getDate()} ${pad(d.getHours())}:${pad(
    d.getMinutes()
  )}`;
}

function DanceCamp26ParticipantsPage() {
  useLoginCheck();

  const [timeSlots, setTimeSlots] = useState([]);
  const [participantTotal, setParticipantTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchParticipants = async () => {
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(
        `${apiUrl}/api/get_dance_camp_26_participants/`,
        {
          credentials: "include",
        }
      );
      if (!response.ok) throw new Error("読み込み失敗");
      const data = await response.json();
      setTimeSlots(data.time_slots || []);
      setParticipantTotal(data.participant_total || 0);
    } catch (error) {
      console.error(error);
      alert("参加者の取得に失敗しました。");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchParticipants();
  }, []);

  const totalParticipants = timeSlots.reduce(
    (acc, slot) =>
      acc +
      slot.lessons.reduce((a, lesson) => a + lesson.participant_count, 0),
    0
  );

  return (
    <div className="dance-camp-26-participants-page">
      <h2 className="page-title">
        SLASH DANCE CAMP 2026 参加者一覧
        <Button
          basic
          size="tiny"
          onClick={fetchParticipants}
          loading={loading}
          className="reload-btn"
        >
          再読込
        </Button>
      </h2>

      <div className="summary">
        <span>
          参加人数: <strong>{participantTotal}</strong>
        </span>
        <span>
          合計申込数: <strong>{totalParticipants}</strong>
        </span>
      </div>

      {timeSlots.length === 0 && !loading && (
        <p className="empty">参加者がいません。</p>
      )}

      {timeSlots.map((slot) => (
        <section key={slot.start_time} className="slot-section">
          <h3 className="slot-title">{formatSlot(slot.start_time)}</h3>
          <div className="lesson-grid">
            {slot.lessons.map((lesson) => (
              <div key={lesson.id} className="lesson-card">
                <div className="lesson-header">
                  <span className={`genre-badge genre-${lesson.genre}`}>
                    {lesson.genre_display}
                  </span>
                  <span className="instructor-name">
                    {lesson.instructor_name}
                  </span>
                  {lesson.room_label && (
                    <span className="room">{lesson.room_label}</span>
                  )}
                  <span className="count">
                    ({lesson.participant_count}名)
                  </span>
                </div>
                <p className="theme">{lesson.theme}</p>

                {lesson.participant_count === 0 ? (
                  <p className="empty-participants">参加者なし</p>
                ) : (
                  <ul className="participants-list">
                    <li className="participant-row header">
                      <span className="cell customer-id">顧客ID</span>
                      <span className="cell name">名前</span>
                      <span className="cell email">メール</span>
                    </li>
                    {lesson.participants.map((p, i) => (
                      <li
                        key={`${lesson.id}-${p.customer_id}-${i}`}
                        className="participant-row"
                      >
                        <span className="cell customer-id">{p.customer_id}</span>
                        <span className="cell name">{p.name}</span>
                        <span className="cell email">{p.email}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}

export default DanceCamp26ParticipantsPage;
